import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import PubSub from './services/pubsub-service';
import * as PubSubActionType from 'services/constants';
import Header from './header';
import { Indicator } from './components/indicators/indicator';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import ModalRoot from './components/Modals';
import Card from 'components/Card/Card.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import componentActions from 'components/actions';
import usersAction from 'User/actions';
import builderAction from 'Builders/actions';
import SetUpBuilderModal from './Builders/Components/SetupBuilderModal';
import authAction from 'Auth/actions';

import * as AuthActionType from './Auth/constants';
import * as SettingActionType from './Setting/constants';
import { AppSettings } from './constants';
import auth from './Auth/authenticator';
import { signalRFactory } from './Factory/SignalRFactory';
import ModalInform from './components/modal-inform';
import UploadingPopup from 'components/UploadingPopup';
import { isWindows } from 'react-device-detect';
import { matchPath } from 'react-router-dom';

class Layout extends Component {
  static propTypes = {
    children: PropTypes.any,
    DisplayName: PropTypes.string,
    Avatar: PropTypes.any,
    routes: PropTypes.array,
    toggleModal: PropTypes.func,
    location: PropTypes.object,
    history: PropTypes.object,
    builderAction: PropTypes.object,
    groupMenu: PropTypes.object,
    SetUpBuilderUser: PropTypes.object,
    authAction: PropTypes.object,
    authReducer: PropTypes.object,
    user: PropTypes.object,
    renderSidebar: PropTypes.func,
    UserProfile: PropTypes.object,
    dispatch: PropTypes.func,
    CustomStyle: PropTypes.object,
    lotProfile: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      showIndicator: false,
      showModalInform: false,
      informMessage: '',
      isInitial: true
    };
  }

  checkRouteToDisplayLotHeader = () => {
    let match;
    if(this.props.routes !== undefined){

    for (let i = 0; i < this.props.routes.length; i++) {
      match = matchPath(this.props.location.pathname, {
        path: this.props.routes[i].path,
        exact: true,
        sensitive: this.props.routes[i].component.sensitive
      });
      if (
        match &&
        this.props.routes[i] &&
        this.props.routes[i].path !== '/' &&
        this.props.routes[i].path !== '/lots' &&
        this.props.routes[i].path !== '/home-hub' &&
        this.props.routes[i].path !== '/my-profile'
      ) {
        return true;
      }
    }
  }
  return false;
  };
  componentDidMount() {
    if (AppSettings.clientTypeValue === 'Builder') {
      let textColor = this.getContrastYIQ(window.profile.customStyleJson.primaryPalette);

      document.body.style.setProperty(
        '--primary-color',
        window.profile.customStyleJson.primaryPalette
      );

      document.body.style.setProperty(
        '--primary-text-color',
        textColor
      );

      document.body.style.setProperty(
        '--secondary-color',
        window.profile.customStyleJson.secondaryPalette
      );

      this.props.dispatch({
        type: SettingActionType.UPDATE_CUSTOM_COLOR_PALETTES_SUCCESS,
        data: window.profile.customStyleJson
      });

      this.props.dispatch({
        type: SettingActionType.SET_CURRENT_CUSTOM_COLOR,
        data: window.profile.customStyleJson
      });
      this.props.dispatch({
        type: SettingActionType.UPDATE_HO_CUSTOM_COLOR_PALETTES_SUCCESS,
        data: window.profile.hobrand
      });

      this.props.dispatch({
        type: SettingActionType.SET_HO_CURRENT_CUSTOM_COLOR,
        data: window.profile.hobrand
      });
    }
    // if (AppSettings.clientTypeValue === 'Homeowner') {
    //   let textColor = this.getContrastYIQ(window.profile.hobrand.primaryPalette);

    //   document.body.style.setProperty(
    //     '--primary-color',
    //     window.profile.hobrand.primaryPalette
    //   );

    //   document.body.style.setProperty(
    //     '--primary-text-color',
    //     textColor
    //   );

    //   document.body.style.setProperty(
    //     '--secondary-color',
    //     window.profile.hobrand.secondaryPalette
    //   );

    //   this.props.dispatch({
    //     type: SettingActionType.UPDATE_HO_CUSTOM_COLOR_PALETTES_SUCCESS,
    //     data: window.profile.hobrand
    //   });

    //   this.props.dispatch({
    //     type: SettingActionType.SET_HO_CURRENT_CUSTOM_COLOR,
    //     data: window.profile.hobrand
    //   });
      
    // }

    /**
     * Handle token dont authorized and expired
     */
    if (localStorage[AppSettings.S1_TOKEN]) {
      this.props.dispatch({
        type: AuthActionType.GET_CURRENT_USER_ASYNC,
        params: null,
        callback: (status,data) => {
          if (AppSettings.clientTypeValue === 'Homeowner') {
            this.props.dispatch({
              type: AuthActionType.SET_HO_BRANDING_LOGO_COLOR,
              params: {token:localStorage[AppSettings.S1_TOKEN], email:data.email},
              callback:(data)=>{
                if(
                 !this.props.lotProfile &&
                  data.length > 0 
                ){
                console.log("Lot list")
                var customStyleJson = JSON.parse(data[0].customStyleJson);
                var primaryPalette =  customStyleJson?customStyleJson.PrimaryPalette:'#4267b2';
                var secondaryPalette = customStyleJson?customStyleJson.SecondaryPalette:"#f06424";
                document.body.style.setProperty(
                  '--primary-color',
                  primaryPalette
                );
          
                document.body.style.setProperty(
                  '--secondary-color',
                  secondaryPalette
                );
              }else if(
                this.checkRouteToDisplayLotHeader() 
                &&
                this.props.lotProfile &&
                this.props.lotProfile.clientInfo &&
                data.length > 0 
              ){
                console.log("Lot detail")
                data.map(hobrand => 
                  {
          
                    if(hobrand.builderId.replace('www.','') === this.props.lotProfile.clientInfo.domain.replace('http://','')){
                      document.body.style.setProperty(
                  '--primary-color',
                  hobrand.PrimaryPalette
                );
          
                document.body.style.setProperty(
                  '--secondary-color',
                  hobrand.SecondaryPalette
                );
                }else{
                console.log("No lot list and no lot detail")
              document.body.style.setProperty(
                    '--primary-color',
                    '#4267b2'
                  );
            
                  document.body.style.setProperty(
                    '--secondary-color',
                    '#f06424'
                  );
                }
              
              }
                );
              }
              }
          })
          }
          if (status) {
            this.setState({ isInitial: false });
          } else {
            // this.props.history.push('/sign-in');
          }
        }
      });
    } else {
      // this.props.history.push('/logout');
    }

    PubSub.subscribe(PubSubActionType.LOADING_INDICATOR, (msg, data) => {
      if (!data.isHideIndicator) {
        this.setState({ showIndicator: true });
      } else {
        //   $("#IndicatorID").hide();
        this.setState({ showIndicator: false });
      }
    });

    /**
     * Handle signalR
     */
    const isLoggedIn = auth.loggedIn();

    if (isLoggedIn) {
      const clientId = AppSettings.CLIENT_ID;
      // const clientName = AppSettings.COMPANY_NAME;
      const host = AppSettings.SITE_ONE_SERVICE_URI;

      signalRFactory.connection(host, { clientId });
    }

    PubSub.subscribe(PubSubActionType.CHANGE_ROLE, (msg, data) => {
      const currentUserId = localStorage[AppSettings.S1_UID];

      if (data.message.userId === currentUserId) {
        this.setState({
          showModalInform: true,
          informMessage:
            'Your role has just been updated by administrator. You will be signed out.'
        });
        auth.logOut();
      }
    });

    PubSub.subscribe(PubSubActionType.REASSIGN_PROJECT_START, (msg, data) => {
      if (data.message.userId !== this.props.authReducer.user.userId) {
        this.setState({
          showModalInform: true,
          informMessage: ' The system is busy. Please wait...',
          isHiddenModalInformButton: true
        });
      }
    });

    PubSub.subscribe(PubSubActionType.REASSIGN_PROJECT_FINISHED, () => {
      setTimeout(() => {
        this.setState({
          showModalInform: false,
          informMessage: '',
          isHiddenModalInformButton: false
        });
      }, 3000);
    });

    PubSub.subscribe(
      PubSubActionType.REASSIGN_MULTIPLE_RFS_START,
      (msg, data) => {
        if (data.message.userId !== this.props.authReducer.user.userId) {
          this.setState({
            showModalInform: true,
            informMessage: ' The system is busy. Please wait...',
            isHiddenModalInformButton: true
          });
        }
      }
    );

    PubSub.subscribe(PubSubActionType.REASSIGN_MULTIPLE_RFS_FINISHED, () => {
      setTimeout(() => {
        this.setState({
          showModalInform: false,
          informMessage: ''
        });
      }, 3000);
    });

    PubSub.subscribe(
      PubSubActionType.REASSIGN_MULTIPLE_WORK_ORDER_START,
      (msg, data) => {
        switch (AppSettings.clientTypeValue) {
          case 'Builder':
            if (data.message.userId !== this.props.authReducer.user.userId) {
              this.setState({
                showModalInform: true,
                informMessage: ' The system is busy. Please wait...',
                isHiddenModalInformButton: true
              });
            }
            break;
          case 'Homeowner':
            if (
              data.message.homeowners.includes(
                this.props.authReducer.user.userId
              )
            ) {
              this.setState({
                showModalInform: true,
                informMessage: ' The system is busy. Please wait...',
                isHiddenModalInformButton: true
              });
            }
            break;
          case 'Subcontractor':
            if (data.message.subcontractors.includes(AppSettings.CLIENT_ID)) {
              this.setState({
                showModalInform: true,
                informMessage: ' The system is busy. Please wait...',
                isHiddenModalInformButton: true
              });
            }
            break;
          default:
            break;
        }
      }
    );

    PubSub.subscribe(
      PubSubActionType.REASSIGN_MULTIPLE_WORK_ORDER_FINISHED,
      () => {
        setTimeout(() => {
          this.setState({
            showModalInform: false,
            informMessage: ''
          });
        }, 3000);
      }
    );

    PubSub.subscribe(PubSubActionType.HOMEOWNER_CHANGE_EMAIL, () => {
      this.setState({
        showModalInform: true,
        informMessage:
          'An activation email has just been sent to your new email address. Please click on the link in the email to activate your account.'
      });
      auth.logOut();
    });

    PubSub.subscribe(PubSubActionType.USER_SUSPENDED, (msg, data) => {
      const { clientId, userId } = data.message;

      if (
        clientId === AppSettings.CLIENT_ID &&
        userId === this.props.authReducer.user.userId
      ) {
        this.setState({
          showModalInform: true,
          informMessage:
            'Your account has been suspended. Please contact your administrator for more information.'
        });
        auth.logOut();
      }
    });

    PubSub.subscribe(PubSubActionType.USER_LOCKED, (msg, data) => {
      if (data.message.userId === this.props.authReducer.user.userId) {
        this.setState({
          showModalInform: true,
          informMessage:
            'Your account has been locked. Please check your mail box for more information.'
        });
        auth.logOut();
      }
    });

    PubSub.subscribe(
      PubSubActionType.IMPORT_REQUEST_FOR_SERVICES_PROGRESS_UPDATE,
      (msg, data) => {
        this.onHandleImportProgressUpdate(data);
      }
    );

    PubSub.subscribe(
      PubSubActionType.IMPORT_WORK_ORDERS_PROGRESS_UPDATE,
      (msg, data) => {
        this.onHandleImportProgressUpdate(data);
      }
    );

    PubSub.subscribe(
      PubSubActionType.IMPORT_PURCHASE_ORDERS_PROGRESS_UPDATE,
      (msg, data) => {
        this.onHandleImportProgressUpdate(data);
      }
    );

    PubSub.subscribe(PubSubActionType.TOAST_SUCCESS, (msg, data) => {
      toast.success(data.msg, {});
    });

    PubSub.subscribe(PubSubActionType.TOAST_ERROR, (msg, data) => {
      toast.error(data.msg, {});
    });

    if (window.profile.clientTypeValue === 'Builder') {
      this.props.builderAction.checkSetupTenantCompletedAsync();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.SetUpBuilderUser.statusCompleted !== null &&
      nextProps.SetUpBuilderUser.statusCompleted === false
    ) {
      this.showSetup();
    }

    if (AppSettings.clientTypeValue === 'Builder') {
      if (!isEqual(nextProps.CustomStyle, this.props.CustomStyle)) {
        let textColor = this.getContrastYIQ(nextProps.CustomStyle.primaryPalette);

        document.body.style.setProperty(
          '--primary-color',
          nextProps.CustomStyle.primaryPalette
        );

        document.body.style.setProperty(
          '--primary-text-color',
          textColor
        );

        document.body.style.setProperty(
          '--secondary-color',
          nextProps.CustomStyle.secondaryPalette
        );
      }
    }
  }

  componentWillUnmount() {
    PubSub.unsubscribe(PubSubActionType.LOADING_INDICATOR);
    PubSub.unsubscribe(PubSubActionType.TOAST_SUCCESS);
    PubSub.unsubscribe(PubSubActionType.TOAST_ERROR);
    PubSub.unsubscribe(PubSubActionType.SYNC_USER_PROFILE);
    PubSub.unsubscribe(PubSubActionType.CHANGE_ROLE);
    PubSub.unsubscribe(PubSubActionType.REASSIGN_PROJECT_START);
    PubSub.unsubscribe(PubSubActionType.REASSIGN_PROJECT_FINISHED);
    PubSub.unsubscribe(
      PubSubActionType.IMPORT_REQUEST_FOR_SERVICES_PROGRESS_UPDATE
    );
    PubSub.unsubscribe(
      PubSubActionType.IMPORT_WORK_ORDERS_PROGRESS_UPDATE
    );
    PubSub.unsubscribe(
      PubSubActionType.IMPORT_PURCHASE_ORDERS_PROGRESS_UPDATE
    );
  }

  getContrastYIQ = (hexcolor) => {
    let color = hexcolor.replace('#', '');
    var r = parseInt(color.substr(0,2),16);
    var g = parseInt(color.substr(2,2),16);
    var b = parseInt(color.substr(4,2),16);
    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    return (yiq >= 128) ? 'black' : 'white';
  }

  onHandleImportProgressUpdate = (data) => {
    const {
      firstConfiguredRowsErrorOccurred,
      numberOfErrorItems,
      numberOfInsertedItems,
      numberOfUpdatedItems,
      totalItems,
      projectName
    } = data.message;

    if (
      numberOfErrorItems + numberOfInsertedItems + numberOfUpdatedItems ===
      totalItems ||
      firstConfiguredRowsErrorOccurred
    ) {
      //dispatch action to dismiss popup importing
      this.props.dispatch({
        type: AuthActionType.REMOVE_ITEM_IN_IMPORT_DATA,
        data: {
          projectName
        }
      });
    }
  }

  showSetup() {
    this.props.toggleModal({
      modalName: 'Setup Builder User',
      modalProps: {
        cancelText: 'Cancel',
        okText: 'Ok',
        title: 'Only one step away from reaching your site',
        show: true,
        history: this.props.history,
        toggleModal: this.props.toggleModal,
        builderAction: this.props.builderAction
      },
      ActiveModal: SetUpBuilderModal
    });
  }

  onCloseModalInform = () => {
    window.location.reload();
  };

  render() {
    const { ImportData } = this.props.authReducer;

    if (this.state.isInitial) {
      return <Indicator id='IndicatorID' show={true} />;
    }
    return (
      <div id='wrapper' className='wrapper'>
        <ModalRoot />

        {this.props.renderSidebar()}
        <div id='page-content-wrapper' className={'main-panel'}>
          <Header
            avatar={this.props.Avatar}
            routes={this.props.routes}
            location={this.props.location}
            history={this.props.history}
          />
          <div className='main-content'>
            <div className='container-fluid'>
              <Card content={this.props.children} />
              <Indicator id='IndicatorID' show={this.state.showIndicator} />
              <ToastContainer position='top-right' autoClose={2000} />
              <ModalInform
                show={this.state.showModalInform}
                content={this.state.informMessage}
                onClose={this.onCloseModalInform}
                isHiddenModalInformButton={this.state.isHiddenModalInformButton}
              />
            </div>
          </div>
        </div>
        {ImportData!== undefined &&ImportData.length > 0 && <UploadingPopup importData={ImportData} />}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const props =
    AppSettings.clientTypeValue === 'Builder'
      ? {
        SetUpBuilderUser: state.BuilderStore.SetUpBuilderUser,
        authReducer: state.authReducer,
        UserProfile: state.UserStore.UserProfile,
        CustomStyle: state.SettingStore.CustomStyle,
        lotProfile: state.LotStore.LotProfile,
      }
      : {
        SetUpBuilderUser: state.BuilderStore.SetUpBuilderUser,
        authReducer: state.authReducer,
        UserProfile: state.UserStore.UserProfile,
        lotProfile: state.LotStore.LotProfile,
      };

  return props;
  
};

const mapDispatchToProps = dispatch => {
  return {
    toggleModal: bindActionCreators(componentActions.toggleModal, dispatch),
    usersAction: bindActionCreators(usersAction, dispatch),
    builderAction: bindActionCreators(builderAction, dispatch),
    authAction: bindActionCreators(authAction, dispatch),
    dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);



// WEBPACK FOOTER //
// ./src/layout.js